export interface SkeletorProps {
    className?: string;
    rounded?: string;
}

export const Skeleton = ({className, rounded}: SkeletorProps) => {
    return(
        <div className={`${className} animate-pulse bg-gray-400/75 ${rounded ? rounded : 'rounded-md'}`}>
            <div className="bg-gray-300 h-7 w-max"></div>
        </div>
    )
}
